import { createApiQueryHook, IApiQueryFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { IReflectiveAnalysisResource } from "../types";

export interface IReflectiveAnalysisQueryParameters {
    reflectiveAnalysis: RelationalValue<IReflectiveAnalysisResource>;
}

export type IReflectiveAnalysisQueryResult = IReflectiveAnalysisResource;

export const reflectiveAnalysisQuery: IApiQueryFunction<IReflectiveAnalysisQueryParameters> = ({
    reflectiveAnalysis,
}) => {
    if (!reflectiveAnalysis) {
        return;
    }

    return {
        method: "GET",
        url: `/reflective_analyses/${mapRelationalValue(reflectiveAnalysis)}`,
    };
};

export const useReflectiveAnalysisQuery = createApiQueryHook<
    IReflectiveAnalysisQueryParameters,
    IReflectiveAnalysisQueryResult
>(reflectiveAnalysisQuery);
